import moment from "moment";
import { baseAxios, errorHandler } from "../index";

const dashboardSyncTasks = [
  {
    label: "History anggota",
    endpoint:
      "webDashboard/totalAnggota?start=2023-01-01&end=2026-12-31",
  },
  {
    label: "History pengajuan",
    endpoint:
      "webDashboard/totalPengajuanHarian?start=2023-01-01&end=2026-12-31",
  },
  {
    label: "Rekap simpanan",
    endpoint:
      "webDashboard/totalSimpananBulanan?startDate=2023-01-01&endDate=2026-12-31",
  },
  {
    label: "Administrasi tahun 2025",
    endpoint: "webDashboard/totalAdminTiapTahun?tahun=2025",
  },
  {
    label: "Administrasi tahun 2026",
    endpoint: "webDashboard/totalAdminTiapTahun?tahun=2026",
  },
];

export async function syncDashboardHistory(onProgress) {
  const results = [];

  for (let index = 0; index < dashboardSyncTasks.length; index += 1) {
    const task = dashboardSyncTasks[index];
    if (onProgress) {
      onProgress({
        current: index + 1,
        total: dashboardSyncTasks.length,
        label: task.label,
      });
    }

    try {
      const response = await baseAxios.post(task.endpoint, null, {
        headers: { token: localStorage.getItem("token") },
      });
      results.push({ label: task.label, data: response.data });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Terjadi kesalahan";
      throw new Error(`${task.label} gagal: ${message}`);
    }
  }

  return results;
}

export async function totalPenyaluran(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/totalPenyaluran",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_TOTAL_PENYALURAN", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function totalNominalLunas(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/totalNominalLunas",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_TOTAL_NOMINAL_LUNAS", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function totalNominalOngoing(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/totalNominalOngoing",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_TOTAL_NOMINAL_ONGOING", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function totalAllPengajuan(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/totalAllPengajuan",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_TOTAL_ALL_PENGAJUAN", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function getTotalKaryawan(dispatch, data, history) {
  try {
    const response = await baseAxios.get("webDashboard/totalKaryawan", {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_TOTAL_KARYAWAN", data: response.data });

    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function totalSimpanan(dispatch, data, history) {
  try {
    const response = await baseAxios.post("webDashboard/totalSimpanan", data, {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_TOTAL_SIMPANAN", data: response.data });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}

export async function getProfitPugar(dispatch, data, history) {
  try {
    const response = await baseAxios.post("webDashboard/profitPugar", data, {
      headers: { token: localStorage.getItem("token") },
    });

    if (data.type === "nominal") {
      dispatch({
        type: "GET_PROFIT_PUGAR_NOMINAL_SUCCESS",
        data: response.data,
      });
    }

    if (data.type === "kuantiti") {
      dispatch({
        type: "GET_PROFIT_PUGAR_KUANTITI_SUCCESS",
        data: response.data,
      });
    }
    dispatch({ type: "SET_GRAND_TOTAL_PROFIT", data: response.data });

    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getPengajuanTrend(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/getPengajuanTrend",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    if (data.type === "nominal") {
      dispatch({
        type: "GET_TREND_PUGAR_NOMINAL_SUCCESS",
        data: response.data,
      });
    }

    if (data.type === "kuantiti") {
      dispatch({
        type: "GET_TREND_PUGAR_KUANTITI_SUCCESS",
        data: response.data,
      });
    }

    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getNominalProfitPugar(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/nominalProfitPugar",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    if (data.type === "nominal") {
      dispatch({
        type: "GET_PROFIT_NOMINAL_PUGAR_NOMINAL_SUCCESS",
        data: response.data,
      });
    }

    if (data.type === "kuantiti") {
      dispatch({
        type: "GET_PROFIT_NOMINAL_PUGAR_KUANTITI_SUCCESS",
        data: response.data,
      });
    }
    dispatch({ type: "SET_GRAND_TOTAL_PROFIT", data: response.data });

    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getUserTrend(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webDashboard/userjoinexit?start=2024-01-01&end=${moment(new Date()).format("yyyy-MM-DD")}`,

      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    dispatch({
      type: "SET_USER_TRACK",
      data: response.data.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getHistoryUserJoinExit(data) {
  try {
    const response = await baseAxios.get(
      `webDashboard/history-user-join-exit?start=${data.start}&end=${data.end}&type=${data.type}&cari=${encodeURIComponent(data.cari || "")}&page=${data.page}&limit=${data.limit}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function exportHistoryUserJoinExit(data) {
  try {
    const response = await baseAxios.get(
      `webDashboard/history-user-join-exit/export?start=${data.start}&end=${data.end}&type=${data.type}&cari=${encodeURIComponent(data.cari || "")}`,
      {
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getPengajuanTrack(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webDashboard/historyPengajuan?start=2024-01-01&end=${moment(new Date()).format("yyyy-MM-DD")}`,

      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    dispatch({
      type: "SET_PENGAJUAN_TRACK",
      data: response.data.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getRekapSimpanan(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webDashboard/rekapSimpanan`,

      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    // console.log(response, "rekap simpanan");
    dispatch({
      type: "SET_REKAP_SIMPANAN",
      data: response.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getRekapAdministrasi(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webDashboard/historyAdmin`,

      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    // console.log(response, "rekap admin");
    dispatch({
      type: "SET_REKAP_ADMIN",
      data: response.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}

export async function getRekapReport(dispatch, data, history) {
  try {
    console.log(data, "dari function tes bulan tahun");
    const response = await baseAxios.get(
      `webDashboard/getPengajuanCairPerTanggal?tglAwal=${data.tgl}&tglAkhir=${data.tgl}`,

      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    console.log(response, "respon tes bulan tahun");
    dispatch({
      type: "SET_REKAP_REPORT",
      data: response.data,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
}
